import { useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Overview as OverviewComponent } from 'modules/trainings/components/Revamp/TrainingsDetail/Overview'
import { OverviewEmptyState } from 'modules/trainings/components/Revamp/TrainingsDetail/Overview/EmptyState'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

function isTrainingEmpty(training: DetailOutletContext['training']) {
  if (!training) return true

  const hasBasicInfo =
    training.description?.length ||
    training.objectives ||
    training.code?.length ||
    training.validFor ||
    training.fundaeSubsidized ||
    training.externalProvider?.length

  const hasCompetenciesOrCategories = training.competencyIds?.length || training.categories?.length

  const hasCosts =
    parseFloat(training.totalTrainingCost) > 0 ||
    parseFloat(training.totalTrainingIndirectCost) > 0 ||
    parseFloat(training.totalTrainingSalaryCost) > 0 ||
    parseFloat(training.totalTrainingSubsidizedCost) > 0

  const hasContent = training.contentModulesConnection?.nodes?.length

  return !hasBasicInfo && !hasCompetenciesOrCategories && !hasCosts && !hasContent
}

export default function Overview() {
  const { training, competencies } = useOutletContext<DetailOutletContext>()

  if (!training || isTrainingEmpty(training)) {
    return <OverviewEmptyState trainingId={Number(training?.id)} />
  }

  return (
    <ResponsivePage.Body showHeader={false} variant="fullscreen">
      <OverviewComponent training={training} competencies={competencies || []} />
    </ResponsivePage.Body>
  )
}
